import { translationCountries } from "../../../constants/countries"

export const isMuditaLink = (link: string) =>
  (/\/\/(www\.)?([a-z0-9]+[.])*mudita\.com/g.test(link) &&
    !link.includes("store.")) ||
  link?.includes("find-your-best-fit")

const addSlashBeforeHash = (link: string) => {
  const [root, hash] = link.split("#")
  return root.endsWith("/") ? root + "#" + hash : root + "/#" + hash
}
const addSlashBeforeQuestionMark = (link: string) => {
  const [root, query] = link.split("?")
  return root.endsWith("/") ? root + "?" + query : root + "/?" + query
}

const downloadableFileExtensions = [".docx", ".pdf"]

export const resolveLink = (link: string) => {
  const foundExtension = downloadableFileExtensions.some((extension) =>
    link.includes(extension)
  )
  if (foundExtension && link.endsWith("/")) {
    return link.slice(0, -1)
  }
  if (link.endsWith("/")) {
    return link
  }
  if (link.includes("#")) {
    return addSlashBeforeHash(link)
  }
  if (link.includes("?")) {
    return addSlashBeforeQuestionMark(link)
  }
  return link + "/"
}

export const isLocaleIncludedToURL = (link: string): boolean => {
  return translationCountries.some(({ pathPrefix }) => {
    if (pathPrefix === "") {
      return false
    } else {
      return link.includes(pathPrefix)
    }
  })
}
